module.exports = __webpack_public_path__ + "static/media/olzhaagro.708e5aba.png";